<ng-container *ngIf="!errorsService.showErrorScreen">
  <survey
    *ngIf="formJsonService.tgForm && surveyService.surveyModel"
    class="survey-component"
    [model]="surveyService.surveyModel">
  </survey>

  <tg-no-result-message *ngIf="false">
  </tg-no-result-message>

  <tg-recn-iframe></tg-recn-iframe>
  <tg-spinner *ngIf="isItLoading()"></tg-spinner>
</ng-container>

<ng-container *ngIf="errorsService.showErrorScreen">
  <tgf-exit-form>
  </tgf-exit-form>
</ng-container>
